/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = { appearances: {}, rules: [], tokens: { borderWidth: 0 } }
export default theme
